/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.EstimageFilter = (function() {

    /**
     * Namespace EstimageFilter.
     * @exports EstimageFilter
     * @namespace
     */
    var EstimageFilter = {};

    EstimageFilter.EstimageFilterModel = (function() {

        /**
         * Properties of an EstimageFilterModel.
         * @memberof EstimageFilter
         * @interface IEstimageFilterModel
         * @property {string|null} [rego] EstimageFilterModel rego
         * @property {string|null} [quoteNo] EstimageFilterModel quoteNo
         * @property {string|null} [claimNo] EstimageFilterModel claimNo
         * @property {number|null} [messageTypeId] EstimageFilterModel messageTypeId
         * @property {number|null} [messageStatusId] EstimageFilterModel messageStatusId
         * @property {string|null} [sortColumn] EstimageFilterModel sortColumn
         * @property {string|null} [sortOrder] EstimageFilterModel sortOrder
         * @property {number|null} [pageIndex] EstimageFilterModel pageIndex
         * @property {number|null} [pageSize] EstimageFilterModel pageSize
         * @property {string|null} [customerNameOrContactNo] EstimageFilterModel customerNameOrContactNo
         */

        /**
         * Constructs a new EstimageFilterModel.
         * @memberof EstimageFilter
         * @classdesc Represents an EstimageFilterModel.
         * @implements IEstimageFilterModel
         * @constructor
         * @param {EstimageFilter.IEstimageFilterModel=} [p] Properties to set
         */
        function EstimageFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * EstimageFilterModel rego.
         * @member {string|null|undefined} rego
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.rego = null;

        /**
         * EstimageFilterModel quoteNo.
         * @member {string|null|undefined} quoteNo
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.quoteNo = null;

        /**
         * EstimageFilterModel claimNo.
         * @member {string|null|undefined} claimNo
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.claimNo = null;

        /**
         * EstimageFilterModel messageTypeId.
         * @member {number|null|undefined} messageTypeId
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.messageTypeId = null;

        /**
         * EstimageFilterModel messageStatusId.
         * @member {number|null|undefined} messageStatusId
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.messageStatusId = null;

        /**
         * EstimageFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.sortColumn = null;

        /**
         * EstimageFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.sortOrder = null;

        /**
         * EstimageFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.pageIndex = null;

        /**
         * EstimageFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.pageSize = null;

        /**
         * EstimageFilterModel customerNameOrContactNo.
         * @member {string|null|undefined} customerNameOrContactNo
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        EstimageFilterModel.prototype.customerNameOrContactNo = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * EstimageFilterModel _rego.
         * @member {"rego"|undefined} _rego
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_rego", {
            get: $util.oneOfGetter($oneOfFields = ["rego"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EstimageFilterModel _quoteNo.
         * @member {"quoteNo"|undefined} _quoteNo
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_quoteNo", {
            get: $util.oneOfGetter($oneOfFields = ["quoteNo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EstimageFilterModel _claimNo.
         * @member {"claimNo"|undefined} _claimNo
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_claimNo", {
            get: $util.oneOfGetter($oneOfFields = ["claimNo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EstimageFilterModel _messageTypeId.
         * @member {"messageTypeId"|undefined} _messageTypeId
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_messageTypeId", {
            get: $util.oneOfGetter($oneOfFields = ["messageTypeId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EstimageFilterModel _messageStatusId.
         * @member {"messageStatusId"|undefined} _messageStatusId
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_messageStatusId", {
            get: $util.oneOfGetter($oneOfFields = ["messageStatusId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EstimageFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EstimageFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EstimageFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EstimageFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EstimageFilterModel _customerNameOrContactNo.
         * @member {"customerNameOrContactNo"|undefined} _customerNameOrContactNo
         * @memberof EstimageFilter.EstimageFilterModel
         * @instance
         */
        Object.defineProperty(EstimageFilterModel.prototype, "_customerNameOrContactNo", {
            get: $util.oneOfGetter($oneOfFields = ["customerNameOrContactNo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified EstimageFilterModel message. Does not implicitly {@link EstimageFilter.EstimageFilterModel.verify|verify} messages.
         * @function encode
         * @memberof EstimageFilter.EstimageFilterModel
         * @static
         * @param {EstimageFilter.IEstimageFilterModel} m EstimageFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EstimageFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.rego != null && Object.hasOwnProperty.call(m, "rego"))
                w.uint32(10).string(m.rego);
            if (m.quoteNo != null && Object.hasOwnProperty.call(m, "quoteNo"))
                w.uint32(18).string(m.quoteNo);
            if (m.claimNo != null && Object.hasOwnProperty.call(m, "claimNo"))
                w.uint32(26).string(m.claimNo);
            if (m.messageTypeId != null && Object.hasOwnProperty.call(m, "messageTypeId"))
                w.uint32(32).int32(m.messageTypeId);
            if (m.messageStatusId != null && Object.hasOwnProperty.call(m, "messageStatusId"))
                w.uint32(40).int32(m.messageStatusId);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(50).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(58).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(64).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(72).int32(m.pageSize);
            if (m.customerNameOrContactNo != null && Object.hasOwnProperty.call(m, "customerNameOrContactNo"))
                w.uint32(82).string(m.customerNameOrContactNo);
            return w;
        };

        /**
         * Encodes the specified EstimageFilterModel message, length delimited. Does not implicitly {@link EstimageFilter.EstimageFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof EstimageFilter.EstimageFilterModel
         * @static
         * @param {EstimageFilter.IEstimageFilterModel} message EstimageFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EstimageFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EstimageFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof EstimageFilter.EstimageFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {EstimageFilter.EstimageFilterModel} EstimageFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EstimageFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.EstimageFilter.EstimageFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.rego = r.string();
                    break;
                case 2:
                    m.quoteNo = r.string();
                    break;
                case 3:
                    m.claimNo = r.string();
                    break;
                case 4:
                    m.messageTypeId = r.int32();
                    break;
                case 5:
                    m.messageStatusId = r.int32();
                    break;
                case 6:
                    m.sortColumn = r.string();
                    break;
                case 7:
                    m.sortOrder = r.string();
                    break;
                case 8:
                    m.pageIndex = r.int32();
                    break;
                case 9:
                    m.pageSize = r.int32();
                    break;
                case 10:
                    m.customerNameOrContactNo = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes an EstimageFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof EstimageFilter.EstimageFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {EstimageFilter.EstimageFilterModel} EstimageFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EstimageFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return EstimageFilterModel;
    })();

    return EstimageFilter;
})();

module.exports = $root;
